import { render, staticRenderFns } from "./standardAcceptance.vue?vue&type=template&id=7bb51d20"
import script from "./standardAcceptance.vue?vue&type=script&lang=js"
export * from "./standardAcceptance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports